export default __webpack_public_path__ + "static/media/vrExperienceBackground.593f7d0e.svg";